module.exports = __webpack_public_path__ + "img/johanna.fa31dc54.png";